/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { LOCATION_LABELS } from '../../../../utils/translations/locationLabels';

import Image from '../../../image/Image.jsx';
import Text from '../../../text/Text.jsx';

import LocationContent from './LocationContent/LocationContent.jsx';
import LocationMap from './LocationMap/LocationMap.jsx';
import LocationHeader from './LocationHeader/LocationHeader.jsx';

const LocationApp = ({ data }) => {
  const { headline, maps, defaultKey, locations, language = 'de' } = data;

  // Verwenden Sie entweder bereitgestellte Labels oder Fallback auf die zentralen Labels
  const labels = {
    ...(LOCATION_LABELS[language] || LOCATION_LABELS.de),
    ...(language === 'en' && data.labelsEn ? data.labelsEn : {}),
    ...(data.labels || {})
  };

  const [currentMap, setCurrentMap] = useState(locations[defaultKey]?.map || Object.keys(maps)[0]);
  const [currentPin, setCurrentPin] = useState(defaultKey);

  useEffect(() => {
    const validPinsForMap = Object.keys(locations).filter((key) => locations[key].map === currentMap);

    if (validPinsForMap.length > 0 && !validPinsForMap.includes(currentPin)) {
      setCurrentPin(validPinsForMap[0]);
    }
  }, [currentMap, currentPin, locations]);

  const handlePinSelect = (pinKey) => {
    if (pinKey && locations[pinKey]) {
      if (locations[pinKey].map !== currentMap) {
        setCurrentMap(locations[pinKey].map);
      }
      setCurrentPin(pinKey);
    }
  };

  return (
    <div className="location__wrapper">
      <LocationHeader headline={headline} />

      {/* Mobile Navigation für Kartenwechsel */}
      <nav className="location__map-navigation-mobile">
        <ul>
          {Object.keys(maps).map((mapKey) => (
            <li key={`mobile-map-switch-${mapKey}`}>
              <button
                className={`button location__switch ${currentMap === mapKey ? 'location__switch--active' : ''}`}
                type="button"
                onClick={() => setCurrentMap(mapKey)}
              >
                <Text tag="span" modifiers={['overline']}>
                  {maps[mapKey].label}
                </Text>
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <LocationContent
        title={labels.sidebarTitle}
        locations={locations}
        currentPin={currentPin}
        currentMap={currentMap}
        onPinSelect={handlePinSelect}
        language={language}
        labels={labels} // Diese Labels werden an LocationAccordion weitergegeben
      >
        <LocationMap
          headline={headline}
          maps={maps}
          currentMap={currentMap}
          onMapSwitch={setCurrentMap}
          currentPin={currentPin}
          title={`${labels.mapLabel} ${maps[currentMap].label}`}
          locations={locations}
          setCurrentPin={handlePinSelect}
          language={language}
        />
      </LocationContent>
    </div>
  );
};

export default LocationApp;
